import { lazy, Suspense, useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";

declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    toasts?: boolean;
  }
}

const Toaster = lazy(() =>
  import("@/components/ui/sonner").then((module) => ({ default: module.Toaster })),
);

/** Load form notifications only on routes that use them, then keep them mounted
 * so a success message survives navigation to another page. */
export function RouteToaster() {
  const required = useRouterState({
    select: (state) => state.matches.some((match) => match.staticData.toasts),
  });
  const [activated, setActivated] = useState(required);

  useEffect(() => {
    if (required) setActivated(true);
  }, [required]);

  return required || activated ? (
    <Suspense fallback={null}>
      <Toaster />
    </Suspense>
  ) : null;
}
